import React from "react";

const CallToWorship = () => {
  return (
    <section className="p-12 text-center bg-gray-900">
      <h2 className="text-3xl font-bold mb-4">Call to Worship</h2>

      <p className="text-lg max-w-2xl mx-auto">
        “Come, let us sing for joy to the Lord; let us shout aloud to the Rock of our salvation.”
        <br />
        <span className="block mt-2 text-green-400 font-semibold">
          — Psalm 95:1
        </span>
      </p>
    </section>
  );
};

export default CallToWorship;